export default __webpack_public_path__ + "static/media/photogallery-01.478c9eb7.webp";